import { render, staticRenderFns } from "./orderTime.vue?vue&type=template&id=16e2c1f8"
import script from "./orderTime.vue?vue&type=script&lang=js"
export * from "./orderTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports